import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { TokenInterceptor } from './interceptor/token.interceptor';
import { ApiService } from './services/api.service';
import { CommonService } from './services/common.service';
import { AuthService } from './services/auth.service';
import { ClientService } from './services/client.service';
import { PagesService } from './services/pages.service';
import { BondService } from './services/bond.service';
import { StateService } from './services/state.service';
import { ReportService } from './services/reports.service';
import { RiderService } from './services/riders.service';
import { DivisionService } from './services/division.service';

@NgModule({
    imports: [],
    providers: [
        ApiService,
        AuthService,
        ClientService,
        CommonService,
        PagesService,
        BondService,
        StateService,
        ReportService,
        RiderService,
        DivisionService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        }
    ],
    declarations: [],
    exports: []
})
export class CoreModule { }
